import { Link } from 'react-router-dom';
import { Smartphone, Mail, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-stripe-dark text-white pt-24 pb-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-24 mb-24">
          {/* Brand */}
          <div className="space-y-8">
            <Link to="/">
              <img src="/assets/images/finovalogoor.png" alt="Finova" className="h-10 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="text-stripe-light text-sm leading-relaxed max-w-xs">
              Empowering individuals and SMEs with fast, transparent, and innovative financial solutions. Build your future with Finova.
            </p>
            <div className="flex gap-4">
              <a href="#" className="p-2 rounded-lg bg-white/5 hover:bg-primary-500/20 text-stripe-light hover:text-white transition-all"><Linkedin size={18} /></a>
              <a href="#" className="p-2 rounded-lg bg-white/5 hover:bg-primary-500/20 text-stripe-light hover:text-white transition-all"><Twitter size={18} /></a>
              <a href="#" className="p-2 rounded-lg bg-white/5 hover:bg-primary-500/20 text-stripe-light hover:text-white transition-all"><Facebook size={18} /></a>
            </div>
          </div>

          {/* Solutions */}
          <div className="space-y-8">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-primary-500">Solutions</h4>
            <div className="flex flex-col gap-4">
              <Link to="/services" className="text-stripe-light hover:text-white transition-colors text-sm">Quick Loans</Link>
              <Link to="/services" className="text-stripe-light hover:text-white transition-colors text-sm">Business Financing</Link>
              <Link to="/services" className="text-stripe-light hover:text-white transition-colors text-sm">Micro-credit</Link>
              <Link to="/services" className="text-stripe-light hover:text-white transition-colors text-sm">Consumer Credit</Link>
            </div>
          </div>

          {/* Company */}
          <div className="space-y-8">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-primary-500">Company</h4>
            <div className="flex flex-col gap-4">
              <Link to="/about" className="text-stripe-light hover:text-white transition-colors text-sm">About Finova</Link>
              <Link to="/privacy" className="text-stripe-light hover:text-white transition-colors text-sm">Privacy Policy</Link>
              <Link to="/terms" className="text-stripe-light hover:text-white transition-colors text-sm">Terms & Conditions</Link>
              <Link to="/contact" className="text-stripe-light hover:text-white transition-colors text-sm">Contact Support</Link>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-8">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-primary-500">Contact</h4>
            <div className="flex flex-col gap-6">
              <div className="flex items-start gap-4">
                <Smartphone size={20} className="text-primary-500" />
                <div>
                  <p className="text-xs font-bold text-stripe-light uppercase tracking-wider mb-1">Call Us</p>
                  <p className="text-sm font-bold">+94 11 234 5678</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Mail size={20} className="text-primary-500" />
                <div>
                  <p className="text-xs font-bold text-stripe-light uppercase tracking-wider mb-1">Email</p>
                  <p className="text-sm font-bold">support@finova.lk</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-xs text-stripe-light font-medium">© {new Date().getFullYear()} Finova (Pvt) Ltd. All rights reserved.</p>
          <div className="flex gap-8">
            <Link to="/terms" className="text-xs text-stripe-light hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/privacy" className="text-xs text-stripe-light hover:text-white transition-colors">Privacy Policy</Link>
            <span className="text-xs text-stripe-light">Cookie Settings</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
